import {video_schema} from './videoSchema'
import {isVideo} from './videoSchema'
import {pauseAllVideo} from './video'
import queryString from 'query-string';
import {error_event} from './analysis'


function cashierLinkAddProductlevel(link) {
  //如果是收银台,增加product_level参数
  try {
    if (/https?:\/\/club\.mgtv\.com\/act\/mgtv_cashier_v2\.html.*/.test(link)) {
      const t = link.split('?');
      let params = {}
      if (t.length > 1) {
        params = queryString.parse(t[1]);
      }
      params['product_level'] = window.gact.is_ott ? 2 : 1;
      params['source'] = window.gact.source
      link = t[0] + '?' + queryString.stringify(params);
    }
    return link
  } catch (e) {
    error_event(e)
    return link
  }

}

export function openLink(link) {
  if (!link) {
    return;
  }
  // console.log(isVideo(link))
  pauseAllVideo(); //跳链之前先暂停视频，为了MgtvApi.jumpPage或者schema打开后，视频仍然在播放的问题

  if (isVideo(link)) { //M站视频链接
    let schema = link;
    if (gact.is_app) {
      if (gact.is_ipad) {
        schema = video_schema(link, 'pad')
      } else {
        schema = video_schema(link, 'mobile')
      }
      openSchema(schema)
    }else{
      window.location.href = link;
    }
  } else if(/^imgotv/.test(link)){ //schecma
    openSchema(link)
  }
  else {
    //如果link是h5收银台，则确保收银台根据环境切换产品包，并带上source。（这个主要场景是为了配置活动收银台）
    link = cashierLinkAddProductlevel(link);
    //跳转
    window.location.href = link;
  }
}


export function openSchema(schema) {
  if (!schema) {
    return;
  }
  if (window.gact.is_app) {
    window.location.href = schema
  } else {
    window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&ios_scheme=${encodeURIComponent(schema)}&android_schema=${encodeURIComponent(schema)}&ckey=CK1393171797859`;
  }

}



// WEBPACK FOOTER //
// ./src/tools/mgtv/link.js